export const en = {
  main: {
    color_hex: 'Color in hexadecimal notation, start with #',
    language: 'English',
    restricted_field_name: 'This field name is reserved and cannot be used',
    asset_type_required: 'Select at least one asset type or make the field global',
    searchbar: 'Search (min. 3 characters)',
    title: 'Admin',
    logout: 'Logout',
    english: 'English',
    dutch: 'Dutch',
    french: 'French',
    spanish: 'Spanish',
    danish: 'Danish',
    italian: 'Italian',
    romanian: 'Romanian',
    norwegian: 'Norwegian',
    german: 'German',
    drop_image: 'Drop your image here',
  },
  ra: {
    tree: {
      add_child_node: 'Add subcategory',
      add_node_after: 'Add category after',
      add_node_before: 'Add category before',
      close: 'Close',
      expand: 'Open',
    },
  },
  resources: {
    categories: {
      name: 'Category |||| Categories',
      fields: {
        name: 'Category name',
      },
    },
    users: {
      name: 'User |||| Users',
      fields: {
        category: 'Category',
        connection: 'Connection',
        email: 'Email',
        familyName: 'Family name',
        firstName: 'First name',
        language: 'Language',
        userRoles: 'Roles',
      },
    },
    priorities: {
      name: 'Priority |||| Priorities',
    },
    branding: {
      name: 'Branding',
    },
    invitations: {
      name: 'Invitation |||| Invitations',
      fields: {
        email: 'Email',
      },
    },
    'asset-types': {
      name: 'Asset Type |||| Asset Types',
      fields: {
        name: 'Name',
      },
    },
    'asset-statuses': {
      name: 'Asset Status |||| Asset Statuses',
      fields: {
        name: 'Name',
      },
    },
    'asset-custom-fields': {
      name: 'Asset Custom Field |||| Asset Custom Fields',
      fields: {
        name: 'Name',
        globalField: 'Global (all asset types)',
        assetTypeIds: 'Asset Types',
      },
    },
  },
}
